import {useEffect} from 'react'
import {useDispatch,useSelector} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Form from 'react-bootstrap/Form'
import LocaleDate from '../../LocaleDate/LocaleDate'
import LocaleCurrency from '../../LocaleCurrency/LocaleCurrency'
import {useSessions} from '../hooks'
import {useMemo,useState} from 'react'
import {useClients} from '../../users/hooks'
import useCurrentUser from '../../../hooks/useCurrentUser'
import {dateToAPIStandard} from '../../../util/util'
import useCurrencySettings from '../../../hooks/useCurrencySettings'
import useApiStatusDispatch from '../../../hooks/useApiStatusDispatch'
import {
	markSessionComplete,
	markSessionIncomplete,
	addSessions,
	editSession
} from './sessionsSlice'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import {envAwarePost,dateToYMD} from '../../../util/util'

const AddSessionModal = ({show,onHide,defaultClientId,showPaymentOptions})=>{
	const {status,clients} = useClients()
	const defaultClient = clients.find(c=>c.user_id_number===parseInt(defaultClientId))
	const [selectedClient,setSelectedClient] = useState(
		Boolean(defaultClientId)
		? {label:defaultClient?.user_name,value:defaultClient?.user_id_number}
		: null
	)

	useEffect(()=>{
		setSelectedClient(
			Boolean(defaultClientId)
				? {label:defaultClient?.user_name,value:defaultClient?.user_id_number}
				: null
		)
	},[defaultClientId,show])

	const [sessionsCount,setSessionsCount] = useState('')
	const [includePayment,setIncludePayment] = useState(false)
	const [paymentAmount,setPaymentAmount] = useState('')
	const [paymentDate,setPaymentDate] = useState(new Date())
	const [paymentNotes,setPaymentNotes] = useState('')
	const [saveStatus,setSaveStatus] = useState('idle')
	
	const statusDispatch = useApiStatusDispatch()


	const reset = ()=>{
		setSelectedClient(null)
		setSessionsCount('')
		setIncludePayment(false)
		setPaymentAmount('')
		setPaymentDate(new Date())
		setPaymentNotes('')
	}

	const handleSave = ()=>{
		const client_id = selectedClient.value
		setSaveStatus('pending')
		statusDispatch(addSessions({
			client_id:selectedClient.value,
			num_sessions:sessionsCount
		}),'sessions','add').then(res=>{
			setSaveStatus('idle')
			if(res.payload.success==='1'){
				reset()
				onHide()
			}
		})
		if(includePayment){
			envAwarePost('api/financials/',{
				action:'createPaymentRecord',
				amount:paymentAmount,
				client_id:selectedClient.value,
				date:dateToYMD(paymentDate),
				comment:paymentNotes,
			})
		}
	}

	return (
		<Modal show={show} onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>
					Add Session
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<strong>Select Client</strong>
				<Select 
					onChange={setSelectedClient}
					value={selectedClient}
					options={clients.map(c=>(
						{
							value:c.user_id_number,
							label:c.user_name
						}
					))}
				/>
				<strong>Number of sessions</strong>
				<Form.Control  
					onChange={ e => { 
						const v = e.target.value
						const newSessionCount = (
							v === '' ? v : Math.max(parseInt(v),1)
						)
						setSessionsCount(newSessionCount) 
					} }
					placeholder="session count" 
					value={sessionsCount}
					type="number"
				/>
				{showPaymentOptions&&
					<Form.Check 
						onChange={ e => {
							setIncludePayment(e.target.checked)
						}}
						checked={includePayment}
						id="include-payment-record-check"
						label="Add a payment record with these sessions (optional)"
					/>
				}
				<div style={{display:includePayment?'block':'none'}}>
					<div>
						<strong>Payment Amount</strong>
						<Form.Control 
							onChange={ e => { setPaymentAmount(e.target.value) } }
							value={paymentAmount}
							placeholder="amount"
						/>
					</div>
					<div>
						<strong className="d-block">Payment Date</strong>
						<DatePicker
							className="form-control"
							onChange={setPaymentDate}
							isClearable
							placeholderText="Select Date"
							customInput={<Form.Control />}
							dateFormat="MMM d, yyyy"
							selected={paymentDate}
						/>
					</div>
					<div>
						<strong>Payment Notes</strong>
						<Form.Control 
							onChange={e=>{ setPaymentNotes(e.target.value) }}
							value={paymentNotes}
							placeholder="notes"
							as="textarea" 
						/>
					</div>
				</div>
				<Button 
					disabled={
						saveStatus==='pending'||
						!sessionsCount || 
						!selectedClient
					}
					onClick={handleSave} 
					variant="outline-success" 
					block className="mt-2"
				>
					<span className="mr-1">Add Sessions<span>{includePayment&&' and Record Payment'}</span></span>
					{saveStatus==='pending'&&<Spinner animation="border" size="sm"/>}
				</Button>
			</Modal.Body>
		</Modal>
	)
}

export default AddSessionModal